// extracted by mini-css-extract-plugin
module.exports = {"container":"jtG16o7yN4qvm7LvnPSeN","firstItem":"_1In0QHiQzxJPIog4uxnwOV","secondItem":"ig4A-TSBka6Hjpsx5Kkm6","toggleLink":"_26iV3yUS33shbcbfDYJizc"};